import { render } from "./LogarView.vue?vue&type=template&id=261cb201&scoped=true"
import script from "./LogarView.vue?vue&type=script&lang=js"
export * from "./LogarView.vue?vue&type=script&lang=js"

import "./LogarView.vue?vue&type=style&index=0&id=261cb201&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261cb201"]])

export default __exports__